<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/ZTQT4g/tc-custom/9780292749221.jpg?1705766128135" alt="This image is the cover for the book Cross Timbers, Personal Narratives of the West"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Cross Timbers, Personal Narratives of the West
      </h1>
      <p class="bookDescription body article font2">
        <p> The activities of a young boy on a small farm in the Texas Cross Timbers during the 1880s seem especially distant today. No one can remember the adventure of a sixteen-and-a-half-mile journey, which consumed the greater part of a day; or hurried predawn dressing in a frosty cold loft while the fragrance of a hearty breakfast wafted upward through the floor cracks; or a two-room schoolhouse, where the last half of Friday afternoon was given over to “speaking pieces” or to spelling and ciphering matches. </p><p> Through the recollections of Edward Everett Dale we are able to view a pattern of life in rural America now gone forever. For <i>The Cross Timbers</i> is a story which, with but a few minor variations, could have been told about a vast number of small boys on farms cleared from the virgin forests in the timbered regions of many states. </p><p> After presenting a brief introduction to the members of the Dale family and the plant, animal, and bird life of the Lower Cross Timbers countryside, the author describes his boyhood of a past century. He tells of his home, its furnishings, and the food served there, as well as the neighbors and relatives who come to visit. We learn of the superstitions, the humorous homespun expressions, the mores of early rural Texans. We hunt and fish with young Master Dale in the thick woods and along the clear creeks. Pioneer life demanded much hard work, but not to the exclusion of a diverting social life—both of which included the youngsters, as the author so graphically relates. Dale tells us also of the religious and secular education of the era, showing the significance of the home in supplementing these two influences. </p><p> Anyone reading this volume must be impressed by the great differences in the lifeways of rural children today and of those of the end of the nineteenth century. </p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Edward Everett Dale, John Biggers
      </h2>
      
      <p class="authorDescription body article"> Edward Everett Dale (1879&ndash;1972) was Research Professor of History at the University of Oklahoma. </p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      The University of Chicago Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?6570c3d9